import React from 'react';

const StatsCard = ({ title, value, change, icon, trend = 'up', color = 'blue' }) => {
  const trendColor = trend === 'up' ? 'text-green-600' : 'text-red-600';
  const trendIcon = trend === 'up' ? '↑' : '↓';
  const changeValue = change ? `${trendIcon} ${Math.abs(change)}%` : '';

  const colorVariants = {
    blue: 'bg-blue-50 text-blue-700 border-blue-200',
    purple: 'bg-purple-50 text-purple-700 border-purple-200',
    green: 'bg-green-50 text-green-700 border-green-200',
    orange: 'bg-orange-50 text-orange-700 border-orange-200',
    pink: 'bg-pink-50 text-pink-700 border-pink-200',
  };

  const currentColor = colorVariants[color] || colorVariants.blue;

  return (
    <div
      className={`group relative w-full sm:w-[260px] md:w-[280px] overflow-hidden rounded-xl border bg-white p-4 shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-1`}
    >
      {/* Accent background */}
      <div
        className={`absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-10 ${currentColor.split(' ')[0]}`}
      />

      <div className="relative z-10">
        {/* Header */}
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
            {title}
          </h3>
          {icon && (
            <div className={`p-1.5 rounded-md ${currentColor}`}>
              <span className="text-base">{icon}</span>
            </div>
          )}
        </div>

        {/* Value */}
        <p className="text-2xl font-bold text-gray-900 md:text-3xl">{value}</p>

        {/* Change indicator */}
        {change !== null && change !== undefined && (
          <div className="flex items-center mt-1">
            <span className={`text-xs font-medium ${trendColor}`}>
              {changeValue}
            </span>
            <span className="ml-1 text-[11px] text-gray-500">from last month</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsCard;
